/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Freight_Status_CustomerInputs */

const vi_order_freight_status_customer = /** @type {(inputs: Order_Freight_Status_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận trả cước`)
};

/**

* @param {Order_Freight_Status_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_freight_status_customer = /** @type {((inputs?: Order_Freight_Status_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Freight_Status_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_freight_status_customer(inputs)
});